import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.variantPreviewModal.title, 'Preview {{name}}'),
  includingTaxes: () => __(translations.variantPreviewModal.includingTaxes, 'VAT incl'),
  matters: () => __(translations.variantPreviewModal.matters, 'Matters'),
};
